<template>
  <div class="gameAreaDiv" :style="{
    borderTopLeftRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTopRightRadius: HNewGameUIConfig.newGameUIType === 0?'20px':'0',
    borderTop: HNewGameUIConfig.newGameUIType === 1 || HNewGameUIConfig.newGameUIType === 4?'':'1px solid #ccc',
  }">
    <div style="display: flex; width: 100%;">
      <div style="width: 76px;">
        <div ref="scrollContainerRef" class="leftCategory" :style="{
        height:bottomContainerHeight+'px',
    }">
          <div v-for="(item, index) in leftIconInfo" :key="index">
            <div v-if="HNewGameUIConfig.newGameUIType===4" @click="changeSwiperPage(index)"
                 :style="{
                    width:'76px',
                    height:'30px',
                    marginBottom:'6px',
                    color:swiperIndex === index?'white':'#888',
                    fontSize:'16px',
                    paddingLeft:'6px',
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    backgroundImage:swiperIndex === index?`url(${iconJmttTitleBg})`:'',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: '100% 100%',
                    backgroundPosition: 'left',
                 }"
               >
              {{item["name"]}}
            </div>
            <HCacheImage v-if="HNewGameUIConfig.newGameUIType!==4" @click="changeSwiperPage(index)" :src="swiperIndex === index?item.icon_press:item.icon"
                         width="60px" :height="HNewGameUIConfig.newGameUIType === 0 ?'60px':'66px'" style="margin-bottom: 6px;"/>
          </div>
        </div>
      </div>
      <div style="width: calc(100% - 76px);position:relative;">
        <HSwiperLR ref="swiperLrRef" :data="data" :onSwipeChange="onSwipeChange" :height="bottomContainerHeight"
                   :resetTopOnChange="true" style="margin-top: 11px;">
          <template #default="{ items, pageIndex }">
            <div class="rightAreaParent">
              <div class="allRowParent" v-for="eachTemplate in items['TemplateList']" :key="eachTemplate['Id']">
                <GameAreaParserTemplate :favoriteCallback="getLobbyData" :eachTemplate="eachTemplate"/>
              </div>
              <!-- “我的”分类下没有收藏游戏时, 仍兜底展示“收藏游戏”分割线 -->
              <div class="allRowParent" v-if="isMineEmpty(items)">
                <GameAreaParserTemplate :favoriteCallback="getLobbyData" :eachTemplate="mineEmptyTemplate"/>
              </div>
            </div>
          </template>
        </HSwiperLR>
        <!-- “我的”分栏底部: 上滑体验热门游戏 动画提示(不挡手势) -->
        <transition name="mineHintFade">
          <div v-if="showMineSwipeHint" class="mineSwipeHint">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6"
                 stroke-linecap="round" stroke-linejoin="round">
              <polyline points="18 15 12 9 6 15"></polyline>
            </svg>
            <div class="mineSwipeHintText">上滑体验更多游戏</div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<script setup>
  import HSwiperLR from "@/components/utils/HSwiperLR.vue";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import GameAreaParserTemplate from "@/components/pages/home/GameAreaParserTemplate.vue";
  import {ref} from "vue";
  import {emitter, hcf} from "@/components/utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const iconJmttTitleBg = hcf.getNewGameUIIcon("flag_choose.png");

  defineProps(["bottomContainerHeight"]);
  let useHttp = useHHttp();

  let swiperIndex = ref(0);
  //居中
  const scrollContainerRef = ref();

  function scrollToCenter(index, isAnimate = true) {
    let targetYValue = 60 * index - 90;
    if (isAnimate) {
      scrollContainerRef.value.scrollTo({
        top: targetYValue,
        behavior: 'smooth'
      });
    } else {
      scrollContainerRef.value.scrollTop = targetYValue;
    }
  }

  function onSwipeChange(index) {
    swiperIndex.value = index;
    // 滚动该图标到容器中间
    scrollToCenter(index);
  }

  function changeSwiperPage(index) {
    swiperLrRef.value.changeSwiperPage(index);
    // 滚动该图标到容器中间
    scrollToCenter(index);
  }

  let data = ref([]);
  let leftIconInfo = ref([]);
  let swiperLrRef = ref();

  // “我的”分栏: 是否没有任何收藏(没有“收藏游戏”模块, 或该模块为空)
  function mineHasNoFav(pageData) {
    if (!pageData || pageData['Name'] !== '我的') return false;
    const tl = pageData['TemplateList'] ?? [];
    const fav = tl.find(t => t && t['Title'] === '收藏游戏');
    return !fav || (fav['ItemList']?.length ?? 0) === 0;
  }
  // “上滑体验热门游戏”提示: 只要当前停在“我的”且没有任何收藏, 就常驻显示(有了收藏后自动消失)
  const showMineSwipeHint = computed(() => {
    const cur = data.value[swiperIndex.value];
    return mineHasNoFav(cur) && swiperIndex.value < data.value.length - 1;
  });

  // “我的”分类没有收藏游戏时, 用这个空模板兜底渲染“收藏游戏”分割线(复用 GameAreaParserTemplate 的标题样式)
  const mineEmptyTemplate = {Id: "__fav_empty__", Title: "收藏游戏", ItemList: []};

  // “我的”分类下若没有“收藏游戏”这条模块(后端无收藏时不下发), 就兜底补一条分割线
  // (有最近游戏等其它模块也照样补; 已自带“收藏游戏”模块则不重复)
  function isMineEmpty(pageData) {
    if (!pageData || pageData["Name"] !== "我的") return false;
    const tl = pageData["TemplateList"] ?? [];
    const hasFav = tl.some(t => t && t["Title"] === mineEmptyTemplate.Title);
    return !hasFav;
  }

  function getLobbyData() {
    useHttp.request("/qp/game/lobby", (respData) => {
      leftIconInfo.value = [];
      data.value = respData.Data;
      for (let each of data.value) {
        leftIconInfo.value.push({
          "icon": each["Icon2"],
          'icon_press': each["Icon1"],
          'name':each['Name'],
        });
      }
    }, {isShowLoading: false})
  }

  onActivated(() => {
    scrollToCenter(swiperIndex.value, false);
  });

  onMounted(() => {
    emitter.on("REFRESH_HOME_LOBBY_LIST", () => {
      getLobbyData();
    });
    getLobbyData();
  });

</script>


<style scoped>
  .leftCategory {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
  }

  .leftCategory::-webkit-scrollbar {
    display: none;
  }

  .gameAreaDiv {
    display: flex;
    flex-direction: row;
    background-color: white;
    border-bottom: none;
    border-left: none;
    border-right: none;
  }

  .rightAreaParent {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .allRowParent {
    display: flex;
    flex-direction: row;
  }

  /* “我的”分栏底部: 上滑体验热门游戏 提示 */
  .mineSwipeHint {
    position: absolute;
    left: 50%;
    bottom: 28px;
    transform: translateX(-50%);
    z-index: 5;
    pointer-events: none; /* 不挡上滑手势 */
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--ct-main-color); /* 箭头(currentColor)与文字都用主题色 */
    animation: mineSwipeBounce 1.4s ease-in-out infinite;
  }

  .mineSwipeHintText {
    color: var(--ct-main-color);
    font-size: 12px;
    margin-top: 1px;
    white-space: nowrap;
  }

  @keyframes mineSwipeBounce {
    0%, 100% { transform: translateX(-50%) translateY(0); }
    50% { transform: translateX(-50%) translateY(-6px); }
  }

  .mineHintFade-enter-active, .mineHintFade-leave-active { transition: opacity 0.3s ease; }
  .mineHintFade-enter-from, .mineHintFade-leave-to { opacity: 0; }
</style>
